import React from 'react';
import styles from './style.module.scss';

interface RadioButtonProps {
  checked?: boolean;
  id: string;
  name: string;
  value?: string | number;
  defaultChecked?: boolean;
  disabled?: boolean;
  dataTestid?: string;
  label?: string;
  variant?: 'small' | 'medium' | 'large';
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
  className?: string;
}

const RadioButton = (props: RadioButtonProps) => {
  const {
    checked,
    id,
    name,
    value,
    defaultChecked,
    dataTestid,
    disabled,
    label = '',
    variant = 'large',
    onChange = () => {},
    onClick = () => {},
    className,
  } = props;

  return (
    <div className={`inline-flex items-start gap-s5 ${className}`}>
      <div className={`${styles.customBtn} ${styles[variant]}`}>
        <input
          id={id}
          type="radio"
          className="cursor-pointer mt-0.5"
          name={name}
          value={value}
          checked={checked}
          data-testid={dataTestid}
          defaultChecked={defaultChecked}
          disabled={disabled}
          onChange={onChange}
          onClick={onClick}
        />
      </div>
      {label?.length !== 0 && (
        <label htmlFor={id} className="max-w-[90%] whitespace-normal break-words cursor-pointer">
          {label}
        </label>
      )}
    </div>
  );
};

export default RadioButton;
